<template lang="pug">
  div
    Divider
    template(v-for="name, i in names")
      Divider(v-if="i", inset=56)
      v-list-item(dense, :to="`/${path}${path?'/':''}${name}`", :key="`/${path}${path?'/':''}${name}`", @contextmenu="click(name, $event)")
        v-list-item-icon.mr-4(v-if="assetBundle.isDir(files[name])"): v-icon mdi-folder
        v-list-item-avatar(tile, v-else, size=32).mr-2.my-1
          v-img(contain, :src="assetBundle.url(files[name].name, {type: 'icon'})")
            template(v-slot:placeholder)
              div.d-flex(style="height: 100%")
                v-icon mdi-file
        v-list-item-content: v-list-item-title {{name}}
    Divider
</template>

<script>
import assetBundle from '@/assetBundle';
import Divider from '@/components/Divider';

export default {
  name: 'List',

  props: ['path'],

  components: { Divider },

  data() {
    return {
      assetBundle,
    };
  },

  computed: {
    files() {
      let files = assetBundle.get(this.path);
      return files;
    },

    names() {
      return Object.keys(this.files).sort((a, b) => {
        return (assetBundle.isDir(this.files[b]) - assetBundle.isDir(this.files[a])) || String.sort(a, b);
      });
    },
  },

  methods: {
    click(name, event) {
      event.preventDefault();
      this.$root.$emit('menu', `${this.path}${this.path ? '/' : ''}${name}`, event.clientX, event.clientY);
    },
  },
};
</script>
